module.exports = __webpack_public_path__ + "img/11st_mal.7390da58.png";